import { Link } from "react-router-dom";
import { FlaskConical } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, inr, useCan } from "@/lib/api";
import { Empty } from "@/components/common";
import { CASE_STATUSES } from "@/components/forms/LabForms";

export default function LabCaseList({ rows, onChanged, hidePatient }) {
  const can = useCan();
  const setStatus = async (c, status) => {
    try { await api.patch(`/lab/cases/${c.id}`, { status }); toast.success("Lab case updated"); onChanged(); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!rows.length) return <Empty icon={FlaskConical} title="No lab cases" text="Cases sent to a lab appear here with their charges." testid="lab-cases-empty" />;
  return (
    <section className="table-card">
      <div className={`table-head ${hidePatient ? "lab-grid-p" : "lab-grid"}`}>{!hidePatient && <span>Patient</span>}<span>Work</span><span>Lab</span><span>Sent / due</span><span>Charge</span><span>Status</span></div>
      {rows.map((c) => {
        const late = c.due_date && c.due_date < new Date().toLocaleDateString("en-CA") && ["sent", "in_progress", "remake"].includes(c.status);
        return (
          <div className={`table-row ${hidePatient ? "lab-grid-p" : "lab-grid"}`} key={c.id} data-testid={`lab-case-row-${c.id}`}>
            {!hidePatient && <Link to={`/patients/${c.patient_id}`} className="patient-link">{c.patient_name}<small>{c.opd}</small></Link>}
            <span><b>{c.work_type}</b>{(c.tooth || c.shade) && <small className="sub block">{[c.tooth && `tooth ${c.tooth}`, c.shade && `shade ${c.shade}`].filter(Boolean).join(" · ")}</small>}</span>
            <span>{c.lab_name}</span>
            <span>{c.sent_date}{c.due_date && <small className={late ? "sub block late" : "sub block"}>due {c.due_date}{late && " · late"}</small>}</span>
            <span className={c.status === "cancelled" ? "amount struck" : "amount"}>{inr(c.charge)}</span>
            {can("lab:cases") ? <select className={`status-select ${c.status}`} value={c.status} onChange={(e) => setStatus(c, e.target.value)} data-testid={`lab-case-status-${c.id}`}>{CASE_STATUSES.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}</select>
              : <span className="badge">{c.status}</span>}
          </div>
        );
      })}
    </section>
  );
}
